import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouteSegment } from '../../../../enums/route-segment.enum';
import { NavBrand } from '../../nav-brand.interface';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-bar',
  templateUrl: './app-bar.component.html',
  styleUrls: ['./app-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatButtonModule, SvgIconComponent, RouterLink, NgIf],
})
export class AppBarComponent {
  @Input() public logo: NavBrand;
  @Input() public showNewQuoteButton = true;
  @Input() public newQuoteLink: RouteSegment[];
  @Input() public onOpenSideNavClick: () => void;
}
